<template>
    <dv-full-screen-container>
      <!--头部开始-->
      <el-row style="height: 10%">
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :sx="24" style="height: 100%">
          <div class="header">
            <div class=" header_time">
              <span class="year">{{ date }}</span>
              <span class="hour" style="margin-left: 10px">{{ time }}</span>
            </div>
  
            <div class="header_left_nav">
              <router-link to="/">
                <button class="butt ">首页</button>
              </router-link>
            </div>
            <div class="header_left_nav nav1" style="z-index: 100000000">
              <router-link to="/Arrondi2" >
                <button class="butt zq" style="left: 20%">文化</button>
              </router-link>
            </div>
  
            <div class=" header_title">
              <div class="header_img">
                <img src="../public/images/tixing.png" alt="">
                <div class="header_title_msg" style="left: 35%">
                  文化振兴
                </div>
              </div>
            </div>
  
            <div class=" nav2 " style="z-index: 100000000">
              <router-link to="/Special2" >
                <button class="butt ">咱们店</button>
              </router-link>
            </div>
            <div class=" nav3">
              <router-link to="/SpecialCoun2" >
                <button class="butt "  style="width: 83px;">金雀田园</button>
              </router-link>
            </div>
            <div class=" nav5">
              <router-link to="/Traditional" >
              <button class="butt" >中药材</button>
              </router-link>
            </div>
            <div class=" nav6">
              <router-link to="/Information" >
                <button class="butt" >数据</button>
              </router-link>
            </div>
            <div class=" nav4">
              <button class="butt" v-on:click="login_out">退出</button>
            </div>
            <div class="clear-both"></div>
  
          </div>
  
        </el-col>
      </el-row>
      <!--头部完毕-->
      <el-row style="height: 55%">
        <el-col :span="8" style="height: 100%">
          <dv-border-box-9>
            <el-tabs type="border-card" class="sell_box">
              <el-tab-pane label="金雀爱心购奶柜机" style="height: 100%">
                <List1 msg="表格数据" style="height: 100%" />
              </el-tab-pane>
            </el-tabs>
          </dv-border-box-9>
        </el-col>
        <el-col :span="8" style="height: 100%" :lazy='true'>
          <div class="map_all" style="text-align: center;">
            <div style="width: 80%;height: auto;">金雀说媒+地方戏曲</div>
            <div class="map_all1" style="width: 30%; text-align: center;">
              <span>累计演出场次</span>
              <span>
                <animate-number from="100" :to="sales_data.money" :key="sales_data.money" duration="4000"></animate-number>
  <!--              {{ sales_data.money }}-->
              </span>
            </div>
  
            <div class="map_all2" style="width: 30%; text-align: center;">
              <span>累计参与相亲人数</span>
              <span>
                <animate-number from="100" :to="sales_data.profit" :key="sales_data.profit" duration="4000"></animate-number>
  <!--              {{ sales_data.profit}}-->
              </span>
            </div>
            <div class="clear-both"></div>
          </div>
          <Map1 msg="地图"/>
        </el-col>
        <el-col :span="8" style="height: 100%">
          <el-col :span="24" style="height: 47%;"  :lazy='true'>
            <dv-border-box-9>
              <div class="title_msg">乡村振兴服务站</div>
              <div style="height: 78%">
              <Bing1 msg="饼图"/>
            </div>
            </dv-border-box-9>
          </el-col>
          <el-col :span="24" style="height: 47%; margin-top: 6%;" :lazy='true'>
            <dv-border-box-9>
              <div class="title_msg">金雀剧场“金鹃说媒+地方戏曲”</div>
              <div style="height: 78%">
                <XList msg="实时" style="padding: 0 3%; width: 94%; height: 100%"/>
                
              </div>
            </dv-border-box-9>
          </el-col>
        </el-col>
      </el-row>
      <el-row style="height: 30%; margin-top: 1%;" >
        <el-col :span="8" style="height: 100%">
          <dv-border-box-9>
            <div class="title_msg">三盘活四帮扶</div>
            <div style="height: 80%; margin-top: 3%;" >
              <SanRankingZhuZhuang msg="排行"   style="padding: 0 3%; width: 94%; height: 100%"/>
            </div>
          </dv-border-box-9>
        </el-col>

  

        <el-col :span="16" style="height: 100%">
          <dv-border-box-9>
            <div class="title_msg">金雀83121</div>
            <div style="height: 77%">
              <SellList1 style="padding: 0 3%; width: 94%; height: 100%" msg="排行"/>
            </div>
          </dv-border-box-9>
        </el-col>
      </el-row>
    </dv-full-screen-container>
  </template>
  
  <script>
  import List1 from '@/views/zhuanqu2/List1.vue'
  import List2 from '@/views/zhuanqu2/List2.vue'
  import Bing1 from '@/views/zhuanqu2/Bing1.vue'
  import SellList1 from '@/views/zhuanqu2/SellList1.vue'
  import SanRanking from '@/views/zhuanqu2/SanRanking.vue'
  import SanRankingZhuZhuang from '@/views/zhuanqu2/SanRankingZhuZhuang.vue'
  import XList from '@/views/zhuanqu2/XList.vue'
  import Map1 from '@/views/map/Map1.vue'
  
  
  export default {
    name: "Arrondi",
    components: {
      List1,
      List2,
      Map1,
      Bing1,
      SellList1,
      SanRanking,
      XList,
      SanRankingZhuZhuang
    },
    data() {
      return {
        sales_data: {
          "money":'100',
          'profit':'528'
        },
        time:'',
        date:''
      }
    },
    mounted(){
  
      let user_id = window.localStorage.getItem('user_id');
  
      // if (!user_id)
      // {
      //   this.$router.push({ path: '/Login' })
      //
      //   return false;
      // }
  
      const data = {
        'user_id': user_id
      };
  
      // this.$api.zq_summary(data).then(res=>
      // {
      //   this.sales_data = res;
      // })
  
  
  
      const that = this;
      setInterval(updateTime, 1000);
      function updateTime() {
        const cd = new Date();
        that.time = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
        that.date = zeroPadding(cd.getFullYear(), 4) + '-' + zeroPadding(cd.getMonth()+1, 2) + '-' + zeroPadding(cd.getDate(), 2);
      };
  
      function zeroPadding(num, digit) {
        let zero = '';
        for(let i = 0; i < digit; i++) {
          zero += '0';
        }
        return (zero + num).slice(-digit);
      }
  
  
    },
    methods: {
      login_out:function(e){
        window.localStorage.clear();
        this.$notify({
          title: '成功',
          message: '退出登录',
          type: 'success'
        });
        this.$router.push({ path: '/Login' })
      }
    }
  }
  
  
  </script>
  
  <style lang="less" scoped>
  @import '../public/less/zhuanqu/zhuanqu.less';
  </style>